import React, {useState} from "react";
import {Box, Button, Slider} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import FlexBox from "view/components/Layout/FlexBox";
import useStyles from "../../styles";

type CropImageProps = {
  imageSource: string;
  defaultScale: number;
  onSave: (scale: number) => void;
  onCancel: () => void;
};
const marks = [
  {
    value: 30,
    label: "30%",
  },
  {
    value: 70,
    label: "70%",
  },
  {
    value: 100,
    label: "100%",
  },
];

const ResizeImage = ({
  imageSource,
  defaultScale,
  onSave,
  onCancel,
}: CropImageProps) => {
  const classes = useStyles();
  const [scale, setScale] = useState<number>(defaultScale);

  return (
    <Box className={classes.container}>
      <FlexBox
        justifyContent="space-between"
        alignCenter
        className={classes.actionButtons}
      >
        <Box mr={2}>
          <Button
            color="primary"
            variant="contained"
            className={classes.iconButton}
            onClick={() => {
              onSave(scale);
            }}
          >
            <CheckIcon />
          </Button>
        </Box>
        <Button
          color="primary"
          variant="outlined"
          className={classes.iconButton}
          onClick={onCancel}
        >
          <CloseIcon />
        </Button>
      </FlexBox>
      <Slider
        defaultValue={100}
        value={scale}
        aria-labelledby="resize-image-slider"
        step={1}
        valueLabelDisplay="auto"
        marks={marks}
        min={10}
        onChange={(e, newValue) => setScale(newValue as number)}
        classes={{
          rail: classes.resizeSliderTrack,
          track: classes.resizeSliderTrack,
          mark: classes.resizeSliderMark,
          markLabel: classes.resizeSliderMarkLabel,
          markLabelActive: classes.resizeSliderMarkLabelActive,
        }}
      />
      <img
        src={imageSource}
        alt=""
        style={{
          maxWidth: "100%",
          transformOrigin: "top left",
          transform: `scale(${scale / 100})`,
        }}
      />
    </Box>
  );
};

export default ResizeImage;
